<style lang="less">
@import "../../../../styles/public/public.less";

.data_download {
  height: 95%;

  // border: 1px solid #00ff00;
  .download_head {
    // margin-top: 18px;
    min-width: 100px;
    color: #66ffff;
    text-align: center;
  }

  .data_content {
    // width: 100%;
    // height: 80%;
    height: 80%;

    // border: 1px solid #0000ff;
    // background-color: transparent;
    .data_content_table_content {
      color: #000000;
      overflow-y: auto;
      height: 75%;
      // margin-top: 5px;
      .ivu-checkbox-inner {
        border-color: #000000;
        background-color: rgba(9, 53, 73, 0.5);
      }

      .ivu-checkbox-checked .ivu-checkbox-inner {
        border-color: #1ce59b;
        background-color: #1ce59b;
      }
    }

    .data_content_table_title {
      color: #000000;
      border-bottom: solid 1px grey;
      border-top: solid 1px grey;
      padding: 5px 0vw;
    }

    .aa {
      img {
        height: 26px;
        width: 28px;
        margin-top: 9px;
      }
    }
  }
}
.ivu-tooltip-inner {
  max-width: 350px !important;
}
</style>
<template>
  <div class="data_download">
    <div v-show="ishow" style="display:flex;width: 100%;height:100%;">
      <div style="height:100%;width: 100%;">
        <div class="display_row_js_ac">
          <div class="download_head">
            <Select v-model="phase" @on-change="changeselect">
              <Option
                v-for="item in datatypeList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </div>
          <div class="display_row_js_ac" style="width: 100px;">
            <div>
              <Upload
                :action="fileAction"
                :show-upload-list="false"
                :on-success="uplloadSucess"
                :on-error="uplloadError"
                :disabled="updataable"
                multiple
              >
                <div @click="updata(this)" v-show="istrue">
                  <Tooltip content="上传" placement="top">
                    <img src="../../../../../static/images/ic_upload.png" />
                    <!-- <div style="color:#66ffff;margin-left: 22px;margin-top:-25px;">上传</div> -->
                  </Tooltip>
                </div>
              </Upload>
            </div>
            <div @click="download">
              <Tooltip content="下载" placement="top">
                <img src="../../../../../static/images/ic_download.png" />
                <!-- <div style="color:#66ffff;margin-left: 22px;margin-top:-25px;">下载</div> -->
              </Tooltip>
            </div>
            <div @click="zipdata">
              <Tooltip content="打包资料" placement="top">
                <img src="../../../../../static/images/ic_bale.png" />
                <!--  <div style="color:#66ffff;margin-left: 22px;margin-top:-25px;">打包</div> -->
              </Tooltip>
            </div>
            <div @click="deletedata">
              <Tooltip content="删除" placement="top">
                <img src="../../../../../static/images/ic_delete.png" />
                <!--  <div style="color:#66ffff;margin-left: 22px;margin-top:-25px;">删除</div> -->
              </Tooltip>
            </div>
          </div>
        </div>

        <div class="data_content" style="margin-top:10px;">
          <Row class="data_content_table_title media_w_w14" style="text-align:center;">
            <Col span="3" style="height:20px;"></Col>
            <Col span="10">文件名称</Col>
            <Col span="3">大小</Col>
            <Col span="8">修改时间</Col>
            <!-- <Col span="5">项目阶段</Col> -->
          </Row>
          <div class="data_content_table_content">
            <div v-show="imgJudge" style="overflow:hidden;height:100%" class="display_row_jc_ac">
              <img style="height:10vh;" src="../../../../../static/images/暂无数据横.png" />
            </div>
            <Row v-show="!imgJudge" v-for="item in dataList">
              <Col span="2" class="display_row_ac" style="padding-top: 12px">
                <Checkbox v-model="item.ischeck"></Checkbox>
              </Col>
              <Col span="1" class="aa">
                <img
                  src="../../../../../static/images/documentPic/ic_pdf.png"
                  v-if="item.filetype=='pdf'"
                />
                <img
                  src="../../../../../static/images/documentPic/ic_ppt.png"
                  v-if="item.filetype=='ppt'||item.filetype=='pptx'"
                />
                <img
                  src="../../../../../static/images/documentPic/ic_word.png"
                  v-if="item.filetype=='doc'||item.filetype=='docx'"
                />
                <img
                  src="../../../../../static/images/documentPic/ic_rar.png"
                  v-if="item.filetype=='zip'||item.filetype=='rar'"
                />
                <img
                  src="../../../../../static/images/documentPic/ic_text.png"
                  v-if="item.filetype=='txt'"
                />
                <img
                  src="../../../../../static/images/documentPic/ic_excel.png"
                  v-if="item.filetype=='xls'||item.filetype=='xlsx'"
                />
                <img
                  src="../../../../../static/images/documentPic/cad.png"
                  v-if="item.filetype=='dwg'||item.filetype=='dwf'"
                />
                <img
                  src="../../../../../static/images/documentPic/视频.png"
                  v-if="item.filetype=='mp4'||item.filetype=='mov'||item.filetype=='avi'||item.filetype=='wmv'"
                />
                <img
                  src="../../../../../static/images/documentPic/图片.png"
                  v-if="item.filetype=='jpg'||item.filetype=='jpeg'||item.filetype=='png'||item.filetype=='bmp'"
                />
                <img
                  src="../../../../../static/images/documentPic/未知.png"
                  v-if="item.filetype!='pdf'&&item.filetype!='ppt'&&item.filetype!='doc'&&item.filetype!='docx'&&item.filetype!='zip'&&item.filetype!='xlsx'&&item.filetype!='xls'&&item.filetype!='txt'&&item.filetype!='mp4'&&item.filetype!='mov'&&item.filetype!='avi'&&item.filetype!='wmv'&&item.filetype!='jpg'&&item.filetype!='jpeg'&&item.filetype!='png'&&item.filetype!='bmp'&&item.filetype!='rar'&&item.filetype!='pptx'"
                />
              </Col>
              <Col span="1">&nbsp;</Col>
              <Col span="8">
                <div
                  style="margin-top:12px;text-align:center;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"
                >
                  <Tooltip :content="item.filename" placement="bottom">
                    <span>{{item.filename}}</span>
                  </Tooltip>
                </div>
              </Col>
              <Col span="1">&nbsp;</Col>
              <Col span="3">
                <div style="margin-top:12px;text-align:center;">
                  <span>{{item.filetsize}}</span>
                </div>
              </Col>
              <Col span="8" style="margin-top:12px;text-align:center;">
                <span>{{item.modfydate}}</span>
              </Col>
              <!-- <Col span="5" style="margin-top:12px;text-align:center;margin-left:-3px">
              <span>{{item.projectPhase}}</span>
              </Col>-->
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!ishow" style="height: 100%;">
      <div style="height: 100%;display:flex;align-items:center;justify-content: center;">
        <img src="../../../../../static/images/权限不足.png" alt="您暂无权限，不可查看当前数据" />
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../../../../app/event";
export default {
  components: {},
  data() {
    return {
      istrue_ys: true,
      istrue: true,
      stepid: 1, //阶段步骤
      index_a: "",
      flag_a: "",
      ishow: true,
      alldata: [], //获取的数据全部存于此
      // proname: "",
      guid: "",
      imgJudge: false, //图片的判断
      phase: "申报阶段",
      status: "",
      // List: [],
      fileAction: "",
      updataable: false,
      datatypeList: [
        {
          label: "申报阶段",
          value: "申报阶段"
        },
        {
          label: "实施阶段",
          value: "实施阶段"
        },
        {
          label: "验收阶段",
          value: "验收阶段"
        }
      ],
      selectedengindoc: [],
      dataList: []
    };
  },
  methods: {
    // 选择工程阶段
    changeselect() {
      let phase = this.phase;
      this.getprochild();
      if (this.phase == "申报阶段") {
        if (this.stepid <= 6) {
          this.istrue = true;
        } else {
          this.istrue = false;
        }
      } else if (this.phase == "实施阶段") {
        if (this.stepid >= 16 && this.stepid <= 18) {
          this.istrue = true;
        } else {
          this.istrue = false;
        }
      } else if (this.phase == "验收阶段") {
        if (
          this.stepid >= 22 &&
          this.stepid <= 26 &&
          this.stepid != 25 &&
          this.stepid != 24
        ) {
          this.istrue = true;
        } else {
          this.istrue = false;
        }
      } else {
        this.istrue = true;
        this.istrue_ys = true;
      }
    },

    /* 操作控制 */
    updata(file) {
      //上传
      if (this.guid != "") {
        this.updataable = false;
        this.fileAction =
          appurl.ip +
          "/ylkjservice/services/hander.ashx?action=uploadfile&PRJNAME=" +
          this.alldata.PRJNAME +
          "&ID=" +
          this.guid +
          "&StageName=" +
          this.phase;
      } else {
        this.$Message.warning("请选择项目阶段！");
      }
    },
    /* 上传失败 */
    uplloadError(error, file, fileLists) {
      this.$Message.error("上传失败");
      return;
    },
    //文件上传成功
    uplloadSucess(response, file, fileLists) {
      let _this = this;
      if (response.success) {
        // bus.$emit("to_center");
        // this.getdata_onle(_this.alldata.ID);
        this.flag_a ? bus.$emit("changeCenter", this.index_a) : null;
        this.getprochild();
        this.$Message.success("上传成功");
      } else {
        this.$Message.error("上传失败");
      }
    },
    download() {
      //下载
      if (this.guid != "") {
        this.changechecxbox();
        let filename = [];
        let checklist = this.selectedengindoc;
        if (this.selectedengindoc.length == 0) {
          this.$Message.warning({
            content: "最少选择一条数据",
            duration: 3
          });
          return;
        } else if (this.selectedengindoc.length == 1) {
          var downurl =
            appurl.downfile +
            "/projectmanager/" +
            this.alldata.PRJNAME +
            "_" +
            this.alldata.ID +
            "/" +
            this.phase +
            "/" +
            checklist[0].filename;
          window.open(downurl);
        } else {
          var _this = this;
          checklist.forEach(item => {
            let name = item.filename;
            filename.push(name);
          });
          this.$http
            .post(
              appurl.ip +
                "/ylkjservice/services/hander.ashx?action=downloadzipfile",
              {
                FileName: filename.toString(),
                PRJNAME: _this.alldata.PRJNAME,
                ID: _this.alldata.ID,
                StageName: _this.phase
              }
            )
            .then(response => {
              if (response.status == 200) {
                let data = response.data;
                let msg = data.msg;
                let name = data.name;
                let downurl = appurl.downfile + name;
                window.open(downurl);
              }
            })
            .catch(error => {
              this.$Message.warning({
                content: "请求失败",
                duration: 3
              });
            });
        }
      } else {
        this.$Message.warning("请选择项目阶段！");
        return;
      }
    },
    zipdata() {
      //打包资料
      if (this.guid == "") {
        this.$Message.warning("请选择项目！");
        return;
      }
      this.changechecxbox();
      let filename = [];
      let checklist = this.selectedengindoc;
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=downloadpro",
          {
            PRJNAME: _this.alldata.PRJNAME,
            ID: _this.alldata.ID
          }
        )
        .then(response => {
          if (response.status == 200) {
            let data = response.data;
            let msg = data.msg;
            let name = data.name;
            let downurl = appurl.downfile + name;
            window.open(downurl);
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "请求失败",
            duration: 3
          });
        });
    },
    deletedata() {
      //删除
      if (this.guid != "") {
        this.changechecxbox();
        if (this.selectedengindoc.length == 0) {
          this.$Message.warning({
            content: "最少选择一条数据",
            duration: 3
          });
          return;
        }
        this.$Modal.confirm({
          title: "删除",
          content: "是否删除当前数据？",
          onOk: () => {
            var _this = this;
            let filename = [];
            let checklist = this.selectedengindoc;
            checklist.forEach(item => {
              let name = item.filename;
              filename.push(name);
            });
            this.$http
              .post(
                appurl.ip +
                  "/ylkjservice/services/hander.ashx?action=deleteAllfolder",
                {
                  FileName: filename.toString(),
                  PRJNAME: _this.alldata.PRJNAME,
                  ID: _this.alldata.ID,
                  StageName: _this.phase
                }
              )
              .then(response => {
                if (response.data.success == true) {
                  // let data = response.data;
                  // let msg = data.msg;
                  this.$Message.warning({
                    // content: msg,
                    content: "文件删除成功!",
                    duration: 3
                  });
                  // bus.$emit("to_center", _this.alldata.ID);
                  // this.getdata_onle(_this.alldata.ID);
                  this.getprochild();
                }
              })
              .catch(error => {
                this.$Message.warning({
                  content: "请求失败",
                  duration: 3
                });
              });
          }
        });
      } else {
        this.$Message.warning("请选择单一的项目阶段！");
        return;
      }
    },
    /* 选择---复选框 */
    changechecxbox() {
      let selectlist = [];
      this.selectedengindoc = [];
      let list = this.dataList;
      list.forEach(element => {
        let select = element.ischeck;
        if (select) {
          selectlist.push(element);
        }
      });
      this.selectedengindoc = selectlist;
    },
    //组件传值，获取当前项目数据
    click_state(data, item, i, flag) {
      if (data == "详细") {
        this.ishow = true;
        if (this.$store.state.user.AOTHOR_ID != 0) {
          //判断是否是园林局的(0:园林局     1:申报单位)
          if (item.DWID != this.$store.state.user.SSDW) {
            //判断是否是本单位的
            //不是
            this.ishow = false;
          } else {
            if (this.$store.state.user.ISADMIN == 0) {
              //判断是否是管理员(0：否  1：是)
              let aa = sessionStorage.getItem("USERCODE");
              if (item.USERCODE != aa) {
                //判断信息是否是登录人员
                this.ishow = false;
                return;
              }
            }
          }
        }
        this.index_a = i;
        this.flag_a = flag;
        if (item.ID != undefined) {
          this.alldata = item;
          this.stepid = item.STEP;
          this.guid = item.ID;
          // this.proname = item.PRJNAME;
          // this.List = item.child;
          this.getprochild();
          this.imgJudge = false;
        } else {
          this.imgJudge = true;
        }
        if (this.phase == "申报阶段") {
          if (this.stepid <= 6) {
            this.istrue = true;
          } else {
            this.istrue = false;
          }
        } else if (this.phase == "实施阶段") {
          if (this.stepid >= 16 && this.stepid <= 18) {
            this.istrue = true;
          } else {
            this.istrue = false;
          }
        } else if (this.phase == "验收阶段") {
          if (this.stepid >= 22 && this.stepid <= 26 && this.stepid != 25) {
            this.istrue = true;
          } else {
            this.istrue = false;
          }
        } else {
          this.istrue = true;
          this.istrue_ys = true;
        }
      }
    },
    // getdata() {
    //   this.dataList = [];
    //   for (var i = 0; i < this.List.length; i++) {
    //     if (this.List[i].filename == this.phase) {
    //       for (var l = 0; l < this.List[i].childrenlist.length; l++) {
    //         this.List[i].childrenlist[l].projectPhase = this.phase;
    //         this.dataList.push(this.List[i].childrenlist[l]);
    //       }
    //     }
    //   }
    // },
    getprochild() {
      let _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=getprochild",
          {
            ID: _this.alldata.ID,
            PRJNAME: _this.alldata.PRJNAME
          }
        )
        .then(res => {
          if (res.status == 200) {
            let List = res.data;
            _this.dataList = [];
            for (var i = 0; i < List.length; i++) {
              if (List[i].filename == _this.phase) {
                for (var l = 0; l < List[i].childrenlist.length; l++) {
                  List[i].childrenlist[l].projectPhase = _this.phase;
                  List[i].childrenlist[l].filetype = List[i].childrenlist[
                    l
                  ].filetype.toLowerCase();
                  // if (List[i].childrenlist[l].filename.length > 10) {
                  //   List[i].childrenlist[l].filename1 =
                  //     List[i].childrenlist[l].filename.substring(0, 8) + "...";
                  // } else {
                  //   List[i].childrenlist[l].filename1 =
                  //     List[i].childrenlist[l].filename;
                  // }
                  _this.dataList.push(List[i].childrenlist[l]);
                }
              }

              _this.getToF();
              // if (_this.dataList.length == 0) {
              //   _this.imgJudge = true;
              // } else {
              //   _this.imgJudge = false;
              // }
            }
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    getToF() {
      if (this.dataList.length == 0) {
        this.imgJudge = true;
      } else {
        this.imgJudge = false;
      }
    }
  },
  mounted() {
    this.getToF();
    bus.$on("center_to", this.click_state);
  },
  beforeDestroy() {
    bus.$off("center_to");
  },
  directives: {}
};
</script>



// WEBPACK FOOTER //
// data_download.vue?7847c672